import { ForkEffect } from 'redux-saga/effects';

import customMetaTagsSaga from './customMetaTags/sagas';
import metaTagsSaga from './metaTags/sagas';

export default (): Array<Generator<ForkEffect<never>, void, unknown>> => {
  return [customMetaTagsSaga(), metaTagsSaga()];
};
